import React, { useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import { Text } from 'react-native'
import { intlFormatDistance, IntlFormatDistanceOptions } from 'date-fns'

interface Props {
  date: Date | string | undefined
  locale?: string
  options?: IntlFormatDistanceOptions
}

const defaultOptions: IntlFormatDistanceOptions = {
  style: 'long',
}

export const useDateAgo = (
  options?: IntlFormatDistanceOptions,
  locale?: string
) => {
  const { i18n } = useTranslation()

  const format = useCallback(
    (date: Date | string | null | undefined) => {
      if (!date) {
        return '—'
      }
      const parsed = typeof date === 'string' ? new Date(date) : date

      return intlFormatDistance(parsed, new Date(), {
        locale: locale || i18n.language,
        ...defaultOptions,
        ...options,
      })
    },
    [i18n.language, locale, options]
  )

  return format
}

export default function DateAgo(props: Props) {
  const format = useDateAgo(props.options, props.locale)

  return <Text>{format(props.date)}</Text>
}
